import { catchError, exhaustMap, switchMap } from 'rxjs/operators';
import {
  setCurrentOrganisationID,
  setOrganisations,
} from '../organisation/organisation.actions';
import { HomeService } from './home.service';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { loadHome } from './home.actions';
import {
  setExternalProjects,
  setRecentProjects,
} from '../projects/project.actions';
import { setIsLoading } from './home.reducer';
import { setUser } from '../user/user.actions';

@Injectable()
export class HomeEffects {
  readonly loadHomeData$: Observable<Action>;

  constructor(
    private readonly actions$: Actions,
    private readonly homeService: HomeService,
  ) {
    this.loadHomeData$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadHome),
        exhaustMap(() => this.homeService.getHome()),
        switchMap(
          ({ user, organisations, recentProjects, externalProjects }) => {
            // -- //
            /* console.log(
            'home-data-II',
            organisations,
            recentProjects,
            externalProjects,
          ); */

            return [
              setUser({ user }),
              setOrganisations({ organisations }),
              organisations.length == 1 &&
                setCurrentOrganisationID({ ID: organisations[0]?.id }),
              setRecentProjects({ projects: recentProjects }),
              setExternalProjects({ projects: externalProjects }),
              setIsLoading({ value: false }),
              // organisations.length == 1 &&
              //   loadOrganisationById({ id: organisations[0]?.id }),
            ].filter(v => !!v);
          },
        ),
        catchError(error => {
          console.error('error', error);
          return [];
        }),
      ),
    );
  }
}
